module.exports = __webpack_public_path__ + "static/media/square_cat.b2e84295.svg";